// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import myAccountDetailsStyles from "@awc/App/SharedStyles/MyAccountDetailsStyles";
import { savedOrderDetailsActionButtonsStyles } from "@awc/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.container = {
    css: css`
        display: flex;
        gap: 16px;
        justify-content: end;

        ${xScreen("lte", "md")} {
            flex-direction: column;
            row-gap: 10px;
            width: 100%;

            & > button {
                width: 100%;
                margin: 0;
            }
        }
    `,
};

savedOrderDetailsActionButtonsStyles.printLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.printLink,
};

savedOrderDetailsActionButtonsStyles.deleteLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.removeAllLink,
};

savedOrderDetailsActionButtonsStyles.addToListLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.addAllToListClickable,
};

savedOrderDetailsActionButtonsStyles.placeOrderLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.placeOrderLink,
};

savedOrderDetailsActionButtonsStyles.deleteButton = {
    css: css`
        margin-left: 0;
    `,
    buttonType: "outline",
    variant: "secondary",
};

savedOrderDetailsActionButtonsStyles.addToListButton = {
    css: css`
        margin-left: 0;
    `,
    buttonType: "outline",
    variant: "secondary",
};

savedOrderDetailsActionButtonsStyles.continueShoppingButton = {
    css: css`
        margin-left: 0;
    `,
};

savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    css: css`
        margin-left: 0;
    `,
};

savedOrderDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
    buttonType: "outline",
};
